(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _Audioplayer = require('./player/Audioplayer');

var _Audioplayer2 = _interopRequireDefault(_Audioplayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Videoplayer from './player/Videoplayer';

// let playlist = {
//     0: {
//         name: 'Run You',
//         band: 'The Qemists',
//         cover: '/uploads/Run_You_The_Qemists.jpeg',
//         src: '/uploads/run_you.mp3'
//     },
//     1: {
//         name: 'Master of the Wind',
//         band: 'Van Canto',
//         cover: '/uploads/Master_of_the_Wind_Van_Canto.jpeg',
//         src: '/uploads/master_of_the_wind.mp3'
//     },
//     2: {
//         name: 'Make It Wit Chu',
//         band: 'Queens Of The Stone Age',
//         cover: '/uploads/Make_It_Wit_Chu_Queens_Of_The_Stone_Age.jpeg',
//         src: '/uploads/make_it_wit_chu.mp3'
//     },
//     3: {
//         name: 'Ooh Ahh (My Life Be Like) (feat. Toby Mac)',
//         band: 'Grits, Toby Mac',
//         cover: '/uploads/grits.jpeg',
//         src: '/uploads/ooh_ahh.mp3'
//     },
//     4: {
//         name: 'Sorry Seems To Be The Hardest Word',
//         band: 'Elton John',
//         cover: '/uploads/Sorry_Seems_To_Be_The_Hardest_Word.jpeg',
//         src: '/uploads/sorry_seems_to_be_the_hardest_word.mp3'
//     }
// };
//
// let audioPlayer = new Audioplayer({
//     playerName: 'Audioplayer',
//     playlist: playlist,
//     templateGen: true,
//     rateList: [0.5, 1, 1.5, 2]
//     // trackScaleTimeSave: false
// });
// audioPlayer.init();
window.Audioplayer = _Audioplayer2.default;
// let videoPlayer = new Videoplayer({
//     playerName: 'Videoplayer',
//     subtitles: {
//         ru: {
//             kind: 'subtitles',
//             label: 'Russian',
//             src: '/uploads/ru_subtitles.vtt'
//         },
//         en: {
//             kind: 'subtitles',
//             label: 'English',
//             src: '/uploads/en_subtitles.vtt'
//         }
//     }
// });
// videoPlayer.init();
// window.videoPlayer = videoPlayer;

},{"./player/Audioplayer":2}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Core2 = require('./components/Core');

var _Core3 = _interopRequireDefault(_Core2);

var _Volume = require('./components/Volume');

var _Volume2 = _interopRequireDefault(_Volume);

var _ScaleProgress = require('./components/ScaleProgress');

var _ScaleProgress2 = _interopRequireDefault(_ScaleProgress);

var _LocalStorage = require('./components/LocalStorage');

var _LocalStorage2 = _interopRequireDefault(_LocalStorage);

var _PlaylistViewModel = require('./views/PlaylistViewModel');

var _PlaylistViewModel2 = _interopRequireDefault(_PlaylistViewModel);

var _ElementsViewModel = require('./views/ElementsViewModel');

var _ElementsViewModel2 = _interopRequireDefault(_ElementsViewModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Audioplayer = function (_Core) {
    _inherits(Audioplayer, _Core);

    function Audioplayer(settings) {
        _classCallCheck(this, Audioplayer);

        var _this = _possibleConstructorReturn(this, (Audioplayer.__proto__ || Object.getPrototypeOf(Audioplayer)).call(this, settings));

        _this.setEventButtonRepeat = function () {
            _this.setRepeat(++_this.defaults.repeat);
        };

        _this.setEventButtonRandom = function () {
            _this.setRandom(!_this.defaults.random);
        };

        _this.setEventVolumeChange = function () {
            if (_this.getPlayerID().muted) {
                _this.elementsViewModel.getElementButtonVolume().title = _this.translate.buttonMuted;
            } else {
                _this.elementsViewModel.getElementButtonVolume().title = _this.translate.buttonVolume;
            }
        };

        _this.setEventRateMenu = function () {
            if (_this.elementsViewModel.getElementRateMenu().style.display === 'block') {
                _this.elementsViewModel.getElementRateMenu().style.display = 'none';
            } else {
                _this.elementsViewModel.getElementRateMenu().style.display = 'block';
            }
        };

        _this.setEventRateMenuItem = function (event) {
            var element = void 0;
            if (event.target.tagName !== 'LI') {
                element = event.target.closest('li');
            } else {
                element = event.target;
            }
            if (parseFloat(element.dataset.playerRate) === _this.defaults.currentRate) {
                _this.elementsViewModel.getElementRateMenu().style.display = 'none';
                return false;
            }
            _this.setRate(element.dataset.playerRate);
            _this.elementsViewModel.getElementRateMenu().style.display = 'none';
        };

        _this.setTrackNext = function () {
            if (_this.defaults.random) {
                _this.setTrack(_this.getRandomIndex(0, Object.keys(_this.defaults.playlist).length));
                _this.playerPlayPause();
            } else {
                if (_this.defaults.repeat === 2) {
                    _this.setTrack(_this.defaults.currentTrack);
                    _this.playerPlayPause();
                } else if (_this.defaults.currentTrack + 1 < Object.keys(_this.defaults.playlist).length) {
                    _this.setTrack(_this.defaults.currentTrack + 1);
                    _this.playerPlayPause();
                } else {
                    if (_this.defaults.repeat === 1) _this.setTrack(0);
                    _this.playerPlayPause();
                }
            }
        };

        _this.setTrackPrev = function () {
            if (_this.scaleProgress.getTimeToPercent(_this.scaleProgress.defaults.currentTime, _this.scaleProgress.defaults.durationTime) > 20) {
                _this.scaleProgress.setScaleTime(0);
                return false;
            }
            if (_this.defaults.random) {
                _this.setTrack(_this.getRandomIndex(0, Object.keys(_this.defaults.playlist).length));
                _this.playerPlayPause();
            } else {
                if (_this.defaults.currentTrack - 1 >= 0) {
                    _this.setTrack(_this.defaults.currentTrack - 1);
                    _this.playerPlayPause();
                } else {
                    if (_this.defaults.repeat === 1) _this.setTrack(Object.keys(_this.defaults.playlist).length - 1);
                    _this.playerPlayPause();
                }
            }
        };

        _this.setTrackItem = function (event) {
            var element = void 0,
                index = void 0;
            if (event.target.tagName !== 'LI') {
                element = event.target.closest('li');
            } else {
                element = event.target;
            }
            index = [].indexOf.call(element.parentNode.children, element);
            if (index === _this.defaults.currentTrack) {
                _this.playerPlayPause();
                return false;
            }
            _this.setTrack(index);
            _this.playerPlayPause();
        };

        _this.setEventSetTrack = function () {
            var setTrackEvent = new CustomEvent('settrack', {
                detail: {
                    playerID: _this.getPlayerID(),
                    currentTrack: _this.defaults.currentTrack
                }
            });
            _this.elementsViewModel.getElementPlayerContainer().dispatchEvent(setTrackEvent);
        };

        _this.setEventEnd = function () {
            if (_this.defaults.random === false && _this.defaults.repeat === 0 && _this.defaults.currentTrack === Object.keys(_this.defaults.playlist).length - 1) {
                _this.scaleProgress.setScaleTime(0);
                return false;
            }
            _this.setTrackNext();
        };

        _this.defaults = Object.assign(_this.defaults, {
            playerName: 'Player',
            playlist: {},
            currentTrack: 0,
            currentRate: 1,
            random: false,
            repeat: 0, // 0 - no repeat, 1 - repeat playlist, 2 - repeat track
            notification: false,
            trackScaleTimeSave: true,
            rateList: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]
        }, settings);
        //Плейлист
        _this.playlistViewModel = new _PlaylistViewModel2.default({
            playerName: _this.defaults.playerName,
            playlist: _this.defaults.playlist
        });
        _this.volume = new _Volume2.default(_this.defaults.playerName, _this.defaults.genHTML);
        _this.scaleProgress = new _ScaleProgress2.default(_this.defaults.playerName, _this.defaults.genHTML);
        _this.elementsViewModel = new _ElementsViewModel2.default(_this.defaults.playerName);
        _this.localStorage = new _LocalStorage2.default(_this.defaults.playerName);
        if (_this.defaults.genHTML) {
            _this.coreViewModel.elements.playerContainer.insertBefore(_this.playlistViewModel.getNodePlaylist(), _this.coreViewModel.elements.playerContainer.firstChild);
            _this.elementsViewModel.createElementButtonPrev();
            _this.elementsViewModel.createElementButtonNext();
            _this.elementsViewModel.createElementButtonRepeat();
            _this.elementsViewModel.createElementButtonRandom();
            if (_this.defaults.currentRate !== null) _this.elementsViewModel.createElementRate(_this.defaults.rateList);
        }
        return _this;
    }

    _createClass(Audioplayer, [{
        key: 'init',
        value: function init() {
            this.setLocale();
            this.volume.init();
            this.scaleProgress.init();
            this.listenEventPause();
            this.listenEventPlay();
            this.listenEventButtonPlay();
            if (this.defaults.currentRate !== null) this.listenEventRateMenu();
            if (this.playlistViewModel instanceof _PlaylistViewModel2.default) {
                this.listenEventPlaylist();
                this.listenEventButtonNext();
                this.listenEventButtonPrev();
            }
            if (this.elementsViewModel instanceof _ElementsViewModel2.default) {
                this.listenEventButtonRepeat();
                this.listenEventButtonRandom();
            }
            if (this.scaleProgress instanceof _ScaleProgress2.default) {
                this.listenEventEnd();
            }
            this.listenEventVolumeChange();
            // Запись в localStorage по умолчанию
            this.localStorage.setLocalStorage({
                currentTrack: this.defaults.currentTrack,
                currentRate: this.defaults.currentRate,
                random: this.defaults.random,
                repeat: this.defaults.repeat,
                volume: this.getPlayerID().volume,
                muted: this.getPlayerID().muted,
                currentTime: this.getPlayerID().currentTime
            });
            // Получение информации из localStorage
            this.setDataFromLocalStorage(this.localStorage.getLocalStorage());
            // Отслеживание изменения параметров и запись в localStorage
            this.localStorage.init();
            if (this.defaults.trackScaleTimeSave) this.localStorage.listenEventCurrentTime();
            //Запрос на показ уведомлений
            if (Notification.permission === 'denied' || Notification.permission === 'default') {
                Notification.requestPermission();
            } else {
                this.defaults.notification = true;
            }
        }
    }, {
        key: 'listenEventPlaylist',
        value: function listenEventPlaylist() {
            var playlistItemList = this.playlistViewModel.getElementPlaylistItem();
            for (var i = 0; i < playlistItemList.length; i++) {
                playlistItemList[i].addEventListener('click', this.setTrackItem);
            }
        }
    }, {
        key: 'listenEventButtonNext',
        value: function listenEventButtonNext() {
            this.elementsViewModel.getElementButtonNext().addEventListener('click', this.setTrackNext);
        }
    }, {
        key: 'listenEventButtonPrev',
        value: function listenEventButtonPrev() {
            this.elementsViewModel.getElementButtonPrev().addEventListener('click', this.setTrackPrev);
        }
    }, {
        key: 'listenEventButtonRepeat',
        value: function listenEventButtonRepeat() {
            this.elementsViewModel.getElementButtonRepeat().addEventListener('click', this.setEventButtonRepeat);
        }
    }, {
        key: 'listenEventButtonRandom',
        value: function listenEventButtonRandom() {
            this.elementsViewModel.getElementButtonRandom().addEventListener('click', this.setEventButtonRandom);
        }
    }, {
        key: 'listenEventEnd',
        value: function listenEventEnd() {
            this.getPlayerID().addEventListener('ended', this.setEventEnd);
        }
    }, {
        key: 'listenEventVolumeChange',
        value: function listenEventVolumeChange() {
            this.getPlayerID().addEventListener('volumechange', this.setEventVolumeChange);
        }
    }, {
        key: 'listenEventRateMenu',
        value: function listenEventRateMenu() {
            this.elementsViewModel.getElementButtonRate().addEventListener('click', this.setEventRateMenu);
            var RateMenuItem = this.elementsViewModel.getElementRateMenuItem();
            for (var i = 0; i < RateMenuItem.length; i++) {
                RateMenuItem[i].addEventListener('click', this.setEventRateMenuItem);
            }
        }
        //TODO Добавить очередь для возвращения по трекам в состоянии Random

        //Установка трека при клике по списку Playlist

    }, {
        key: 'setTrack',
        value: function setTrack(index) {
            //TODO Отлавливать ошибку, если по индексу ничего не найдено
            this.playlistViewModel.getElementPlaylistItem()[this.defaults.currentTrack].classList.remove('__current');
            this.defaults.currentTrack = index;
            this.getPlayerID().src = this.defaults.playlist[index].src;
            this.playlistViewModel.getElementPlaylistItem()[index].classList.add('__current');
            this.getPlayerID().removeEventListener('canplay', this.setEventSetTrack);
            this.getPlayerID().addEventListener('canplay', this.setEventSetTrack);
            if (this.defaults.currentRate !== null) this.setRate(this.defaults.currentRate);
            var notify = this.setNotification(this.defaults.playlist[index].name, this.defaults.playlist[index].band, this.defaults.playlist[index].cover);
            notify.onclick = function () {
                window.focus();
                notify.close();
            };
        }
        //Генерация события изменения currentTrack

    }, {
        key: 'setRepeat',
        value: function setRepeat(index) {
            var varRepeat = void 0;
            index <= 2 && index >= 0 ? varRepeat = index : varRepeat = 0;
            switch (varRepeat) {
                case 0:
                    this.defaults.repeat = varRepeat;
                    this.coreViewModel.getElementPlayerContainer().classList.remove(this.elementsViewModel.classes.repeatTrack);
                    this.elementsViewModel.getElementButtonRepeat().title = this.translate.buttonRepeat;
                    break;
                case 1:
                    this.defaults.repeat = varRepeat;
                    this.coreViewModel.getElementPlayerContainer().classList.add(this.elementsViewModel.classes.repeatPlaylist);
                    this.elementsViewModel.getElementButtonRepeat().title = this.translate.buttonRepeatPlaylist;
                    break;
                case 2:
                    this.defaults.repeat = varRepeat;
                    this.coreViewModel.getElementPlayerContainer().classList.remove(this.elementsViewModel.classes.repeatPlaylist);
                    this.coreViewModel.getElementPlayerContainer().classList.add(this.elementsViewModel.classes.repeatTrack);
                    this.elementsViewModel.getElementButtonRepeat().title = this.translate.buttonRepeatTrack;
                    break;
            }
            //Генерация события изменения repeat
            var setRepeatEvent = new CustomEvent('repeatchange', {
                detail: {
                    repeat: this.defaults.repeat
                }
            });
            this.elementsViewModel.getElementPlayerContainer().dispatchEvent(setRepeatEvent);
        }
    }, {
        key: 'setRandom',
        value: function setRandom(bool) {
            if (bool) {
                this.defaults.random = bool;
                this.coreViewModel.getElementPlayerContainer().classList.add(this.elementsViewModel.classes.random);
                this.elementsViewModel.getElementButtonRandom().title = this.translate.buttonRandom;
            } else {
                this.defaults.random = bool;
                this.coreViewModel.getElementPlayerContainer().classList.remove(this.elementsViewModel.classes.random);
                this.elementsViewModel.getElementButtonRandom().title = this.translate.buttonRandomOff;
            }
            //Генерация события изменения random
            var setRandomEvent = new CustomEvent('randomchange', {
                detail: {
                    random: this.defaults.random
                }
            });
            this.elementsViewModel.getElementPlayerContainer().dispatchEvent(setRandomEvent);
        }
    }, {
        key: 'setRate',
        value: function setRate(value) {
            var queryRateMenuItemCurrent = this.elementsViewModel.getElementRateMenu().querySelector('.__current');
            if (queryRateMenuItemCurrent) queryRateMenuItemCurrent.classList.remove('__current');
            this.defaults.currentRate = parseFloat(value);
            this.getPlayerID().playbackRate = this.defaults.currentRate;
            this.elementsViewModel.getElementButtonRate().innerText = 'x' + this.defaults.currentRate;
            queryRateMenuItemCurrent = this.elementsViewModel.getElementRateMenu().querySelector('[data-player-rate="' + this.defaults.currentRate + '"]');
            if (queryRateMenuItemCurrent) queryRateMenuItemCurrent.classList.add('__current');
            //Генерация события изменения random
            var setRateEvent = new CustomEvent('setrate', {
                detail: {
                    currentRate: this.defaults.currentRate
                }
            });
            this.elementsViewModel.getElementPlayerContainer().dispatchEvent(setRateEvent);
        }
    }, {
        key: 'setDataFromLocalStorage',
        value: function setDataFromLocalStorage(object) {
            var _this2 = this;

            this.setTrack(parseInt(object.currentTrack));
            if (this.defaults.currentRate !== null) this.setRate(object.currentRate);
            this.setRandom(object.random === 'true');
            this.setRepeat(parseInt(object.repeat));
            this.getPlayerID().volume = parseFloat(object.volume);
            this.getPlayerID().muted = object.muted === 'true';
            if (this.defaults.trackScaleTimeSave) {
                setTimeout(function () {
                    _this2.getPlayerID().currentTime = parseFloat(object.currentTime);
                }, 500);
            }
        }
    }, {
        key: 'setNotification',
        value: function setNotification(title, body, cover) {
            return new Notification(title, { body: body, icon: cover });
        }
    }, {
        key: 'setLocale',
        value: function setLocale() {
            this.coreViewModel.getButtonPlay().title = this.translate.buttonPlay;
            this.elementsViewModel.getElementButtonPrev().title = this.translate.buttonPrev;
            this.elementsViewModel.getElementButtonNext().title = this.translate.buttonNext;
            this.elementsViewModel.getElementButtonVolume().title = this.translate.buttonVolume;
            this.elementsViewModel.getElementButtonRepeat().title = this.translate.buttonRepeat;
            this.elementsViewModel.getElementButtonRandom().title = this.translate.buttonRandom;
            if (this.defaults.currentRate !== null) this.elementsViewModel.getElementButtonRate().title = this.translate.buttonRate;
        }
    }, {
        key: 'setPlayerStatusPlay',
        value: function setPlayerStatusPlay() {
            this.coreViewModel.getElementPlayerContainer().classList.add(this.coreViewModel.classes.playing);
            this.playlistViewModel.getElementPlaylist().classList.add(this.coreViewModel.classes.playing);
            this.coreViewModel.getButtonPlay().title = this.translate.buttonPause;
        }
    }, {
        key: 'setPlayerStatusPause',
        value: function setPlayerStatusPause() {
            this.coreViewModel.getElementPlayerContainer().classList.remove(this.coreViewModel.classes.playing);
            this.playlistViewModel.getElementPlaylist().classList.remove(this.coreViewModel.classes.playing);
            this.coreViewModel.getButtonPlay().title = this.translate.buttonPlay;
        }
    }, {
        key: 'getRandomIndex',
        value: function getRandomIndex(min, max) {
            var varRandom = parseInt(Math.random() * (max - min) + min);
            for (var i = 0; varRandom === this.defaults.currentTrack; i++) {
                varRandom = parseInt(Math.random() * (max - min) + min);
            }
            return varRandom;
        }
    }]);

    return Audioplayer;
}(_Core3.default);

exports.default = Audioplayer;

},{"./components/Core":3,"./components/LocalStorage":4,"./components/ScaleProgress":5,"./components/Volume":7,"./views/ElementsViewModel":9,"./views/PlaylistViewModel":10}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CoreViewModel = require('../views/CoreViewModel');

var _CoreViewModel2 = _interopRequireDefault(_CoreViewModel);

var _Translate = require('./Translate');

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Core = function () {
    function Core(settings) {
        var _this = this;

        _classCallCheck(this, Core);

        this.playerPlayPause = function () {
            if (_this.getCheckSupport()) {
                if (_this.getPlayerID().paused) {
                    //Остановка остальных плееров на странице
                    _this.setOtherPlayersPause();
                    _this.getPlayerID().play();
                } else {
                    _this.getPlayerID().pause();
                }
            }
        };

        this.setPlayerStatusPlay = function () {
            _this.coreViewModel.getElementPlayerContainer().classList.add(_this.coreViewModel.classes.playing);
            _this.coreViewModel.getButtonPlay().title = _this.translate.buttonPause;
        };

        this.setPlayerStatusPause = function () {
            _this.coreViewModel.getElementPlayerContainer().classList.remove(_this.coreViewModel.classes.playing);
            _this.coreViewModel.getButtonPlay().title = _this.translate.buttonPlay;
        };

        this.defaults = Object.assign({
            playerName: 'Player',
            mimeTypes: ['audio/mpeg;'],
            locale: 'ru',
            localeObject: {},
            subtitles: {},
            genHTML: true
        }, settings);
        this.coreViewModel = new _CoreViewModel2.default(this.defaults.playerName);
        if (this.defaults.genHTML) this.coreViewModel.createView(this.defaults.subtitles);
        // Локализация
        this.translate = new _Translate2.default(this.defaults.locale, this.defaults.localeObject);
        this.otherPlayersID = [];
        for (var i = 0; i < Object.keys(document.querySelectorAll('audio')).length; i++) {
            this.otherPlayersID.push(document.querySelectorAll('audio')[i].getAttribute('id'));
        }
        for (var _i = 0; _i < Object.keys(document.querySelectorAll('video')).length; _i++) {
            this.otherPlayersID.push(document.querySelectorAll('video')[_i].getAttribute('id'));
        }
    }

    _createClass(Core, [{
        key: 'init',
        value: function init() {
            this.listenEventPause();
            this.listenEventPlay();
            this.listenEventButtonPlay();
        }
    }, {
        key: 'listenEventButtonPlay',
        value: function listenEventButtonPlay() {
            this.coreViewModel.getButtonPlay().addEventListener('click', this.playerPlayPause);
        }
    }, {
        key: 'listenEventPlay',
        value: function listenEventPlay() {
            this.getPlayerID().addEventListener('play', this.setPlayerStatusPlay);
        }
    }, {
        key: 'listenEventPause',
        value: function listenEventPause() {
            this.getPlayerID().addEventListener('pause', this.setPlayerStatusPause);
        }
    }, {
        key: 'listenEventEnd',
        value: function listenEventEnd() {
            this.getPlayerID().addEventListener('ended', this.setPlayerStatusPause);
        }
    }, {
        key: 'setOtherPlayersPause',
        value: function setOtherPlayersPause() {
            if (this.otherPlayersID.length > 1) {
                for (var i = 0; i < this.otherPlayersID.length; i++) {
                    if (this.defaults.playerName !== this.otherPlayersID[i]) document.getElementById(this.otherPlayersID[i]).pause();
                }
            }
        }
    }, {
        key: 'getCheckSupport',
        value: function getCheckSupport() {
            return !!this.getPlayerID().canPlayType(this.defaults.mimeTypes);
        }
    }, {
        key: 'getPlayerID',
        value: function getPlayerID() {
            return document.getElementById(this.defaults.playerName);
        }
    }, {
        key: 'getPlayerName',
        value: function getPlayerName() {
            return this.defaults.playerName;
        }
    }]);

    return Core;
}();

exports.default = Core;

},{"../views/CoreViewModel":8,"./Translate":6}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ElementsViewModel = require('../views/ElementsViewModel');

var _ElementsViewModel2 = _interopRequireDefault(_ElementsViewModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocalStorage = function () {
    function LocalStorage() {
        var _this = this;

        var playerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Player';

        _classCallCheck(this, LocalStorage);

        this.setRandom = function (event) {
            localStorage.setItem(_this.playerName + 'random', event.detail.random);
        };

        this.setRepeat = function (event) {
            localStorage.setItem(_this.playerName + 'repeat', event.detail.repeat);
        };

        this.setVolume = function () {
            localStorage.setItem(_this.playerName + 'volume', _this.playerID.volume);
        };

        this.setMuted = function (event) {
            localStorage.setItem(_this.playerName + 'muted', event.detail.muted);
        };

        this.setTrack = function (event) {
            localStorage.setItem(_this.playerName + 'currentTrack', event.detail.currentTrack);
        };

        this.setRate = function (event) {
            localStorage.setItem(_this.playerName + 'currentRate', event.detail.currentRate);
        };

        this.setSubtitles = function (event) {
            localStorage.setItem(_this.playerName + 'currentSubtitles', event.detail.currentSubtitles);
        };

        this.setEventCurrentTime = function (event) {
            localStorage.setItem(_this.playerName + 'currentTime', event.detail.currentTime);
        };

        this.setEventCurrentTimePlay = function (event) {
            _this.setCurrentTime(event);
            clearInterval(_this.currentTimeInterval);
            _this.currentTimeInterval = setInterval(function () {
                _this.setCurrentTime(event);
            }, _this.currentTimeIntervalPeriod);
        };

        this.setEventCurrentTimePause = function () {
            clearInterval(_this.currentTimeInterval);
        };

        this.setCurrentTime = function (event) {
            localStorage.setItem(_this.playerName + 'currentTime', event.target.currentTime);
        };

        this.playerName = playerName;
        this.playerID = document.getElementById(this.playerName);
        this.defaults = [];
        this.elementsViewModel = new _ElementsViewModel2.default(this.playerName);
        this.currentTimeInterval = null;
        this.currentTimeIntervalPeriod = 5000;
    }

    _createClass(LocalStorage, [{
        key: 'init',
        value: function init() {
            this.listenEventVolume();
            this.listenEventMuted();
            this.listenEventRandom();
            this.listenEventRepeat();
            this.listenEventSetTrack();
            this.listenEventSetRate();
            this.listenEventSetSubtitles();
        }
    }, {
        key: 'listenEventRandom',
        value: function listenEventRandom() {
            this.elementsViewModel.getElementPlayerContainer().addEventListener('randomchange', this.setRandom);
        }
    }, {
        key: 'listenEventRepeat',
        value: function listenEventRepeat() {
            this.elementsViewModel.getElementPlayerContainer().addEventListener('repeatchange', this.setRepeat);
        }
    }, {
        key: 'listenEventVolume',
        value: function listenEventVolume() {
            this.playerID.addEventListener('volumechange', this.setVolume);
        }
    }, {
        key: 'listenEventMuted',
        value: function listenEventMuted() {
            this.elementsViewModel.getElementPlayerContainer().addEventListener('mutedchange', this.setMuted);
        }
    }, {
        key: 'listenEventSetTrack',
        value: function listenEventSetTrack() {
            this.elementsViewModel.getElementPlayerContainer().addEventListener('settrack', this.setTrack);
        }
    }, {
        key: 'listenEventSetRate',
        value: function listenEventSetRate() {
            this.elementsViewModel.getElementPlayerContainer().addEventListener('setrate', this.setRate);
        }
    }, {
        key: 'listenEventSetSubtitles',
        value: function listenEventSetSubtitles() {
            this.elementsViewModel.getElementPlayerContainer().addEventListener('setsubtitles', this.setSubtitles);
        }
    }, {
        key: 'listenEventCurrentTime',
        value: function listenEventCurrentTime() {
            this.elementsViewModel.getElementPlayerContainer().addEventListener('setcurrenttime', this.setEventCurrentTime);
            this.playerID.addEventListener('play', this.setEventCurrentTimePlay);
            this.playerID.addEventListener('pause', this.setEventCurrentTimePause);
        }
    }, {
        key: 'setLocalStorage',
        value: function setLocalStorage(object) {
            for (var item in object) {
                if (localStorage.getItem(this.playerName + item) === null) localStorage.setItem(this.playerName + item, object[item]);
                this.defaults.push(this.playerName + item);
            }
        }
    }, {
        key: 'getRandom',
        value: function getRandom() {
            return localStorage.getItem(this.playerName + 'random');
        }
    }, {
        key: 'getRepeat',
        value: function getRepeat() {
            return localStorage.getItem(this.playerName + 'repeat');
        }
    }, {
        key: 'getVolume',
        value: function getVolume() {
            return localStorage.getItem(this.playerName + 'volume');
        }
    }, {
        key: 'getMuted',
        value: function getMuted() {
            return localStorage.getItem(this.playerName + 'muted');
        }
    }, {
        key: 'getTrack',
        value: function getTrack() {
            return localStorage.getItem(this.playerName + 'currentTrack');
        }
    }, {
        key: 'getRate',
        value: function getRate() {
            return localStorage.getItem(this.playerName + 'currentRate');
        }
    }, {
        key: 'getSubtitles',
        value: function getSubtitles() {
            return localStorage.getItem(this.playerName + 'currentSubtitles');
        }
    }, {
        key: 'getCurrentTime',
        value: function getCurrentTime() {
            return localStorage.getItem(this.playerName + 'currentTime');
        }
    }, {
        key: 'getLocalStorage',
        value: function getLocalStorage() {
            var object = {};
            for (var i = 0; i < this.defaults.length; i++) {
                object[this.defaults[i].replace(this.playerName, '')] = localStorage[this.defaults[i]];
            }
            return object;
        }
    }]);

    return LocalStorage;
}();

exports.default = LocalStorage;

},{"../views/ElementsViewModel":9}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ElementsViewModel = require('../views/ElementsViewModel');

var _ElementsViewModel2 = _interopRequireDefault(_ElementsViewModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScaleProgress = function () {
    function ScaleProgress() {
        var _this = this;

        var playerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Player';
        var genHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, ScaleProgress);

        this.setEventScaleTimeMouseUp = function (event) {
            _this.defaults.bufferedIndex++;
            _this.defaults.mouseMove = false;
            _this.setScaleTime((event.clientX - _this.defaults.scaleTimeSize[0]) / _this.getScaleWidth() * 100);
            document.removeEventListener('mouseup', _this.setEventScaleTimeMouseUp);
            var setCurrentTimeEvent = new CustomEvent('setcurrenttime', {
                detail: {
                    currentTime: _this.defaults.currentTime
                }
            });
            _this.elementsViewModel.getElementPlayerContainer().dispatchEvent(setCurrentTimeEvent);
        };

        this.setEventScaleTimeMouseDown = function () {
            _this.defaults.mouseMove = true;
            _this.defaults.scaleTimeSize = _this.getScalePoints();
            document.removeEventListener('mouseup', _this.setEventScaleTimeMouseUp);
            document.addEventListener('mouseup', _this.setEventScaleTimeMouseUp);
        };

        this.setEventScaleTimeMouseMove = function (event) {
            if (_this.defaults.mouseMove) {
                _this.setScaleTime((event.clientX - _this.defaults.scaleTimeSize[0]) / _this.getScaleWidth() * 100);
            }
        };

        this.setEventTimeUpdate = function () {
            _this.setTimeCurrent(_this.defaults.playerID.currentTime);
            _this.setScaleTimeProgress(_this.defaults.playerID.currentTime / _this.defaults.durationTime * 100);
        };

        this.setEventProgress = function () {
            if (_this.defaults.playerID.buffered.length > 0) _this.setScaleTimeBuffered(_this.getTimeToPercent(_this.defaults.playerID.buffered.end(_this.defaults.playerID.buffered.length - 1), _this.defaults.durationTime));
        };

        this.setEventSetTrack = function (event) {
            _this.setTimeCurrent(_this.defaults.currentTime);
            _this.setTimeDuration(event.detail.playerID);
            _this.setScaleTimeBuffered(0);
        };

        this.defaults = {
            playerName: playerName,
            playerID: document.getElementById(playerName),
            durationTime: 0,
            currentTime: 0,
            bufferedTime: 0,
            loadeddata: false,
            mouseMove: false,
            scaleTimeSize: [],
            genHTML: genHTML
        };
        this.elementsViewModel = new _ElementsViewModel2.default(this.defaults.playerName);
        if (this.defaults.genHTML) this.elementsViewModel.createElementScaleProgress();
    }

    _createClass(ScaleProgress, [{
        key: 'init',
        value: function init() {
            this.listenEventSetTrack();
            this.listenEventTimeUpdate();
            this.listenEventScaleTime();
            this.listenEventProgress();
        }
    }, {
        key: 'listenEventSetTrack',
        value: function listenEventSetTrack() {
            this.elementsViewModel.getElementPlayerContainer().addEventListener('settrack', this.setEventSetTrack);
        }
    }, {
        key: 'listenEventProgress',
        value: function listenEventProgress() {
            this.defaults.playerID.addEventListener('progress', this.setEventProgress);
        }
    }, {
        key: 'listenEventTimeUpdate',
        value: function listenEventTimeUpdate() {
            this.defaults.playerID.addEventListener('timeupdate', this.setEventTimeUpdate);
        }
    }, {
        key: 'listenEventScaleTime',
        value: function listenEventScaleTime() {
            this.elementsViewModel.getElementScaleTime().addEventListener('mousedown', this.setEventScaleTimeMouseDown);
            this.elementsViewModel.getElementScaleTime().addEventListener('mousemove', this.setEventScaleTimeMouseMove);
        }
    }, {
        key: 'setTimeCurrent',
        value: function setTimeCurrent(value) {
            this.defaults.currentTime = value;
            this.elementsViewModel.getElementPlayerTimeCurrent().innerHTML = this.getTimeConvert(this.defaults.currentTime);
        }
    }, {
        key: 'setTimeDuration',
        value: function setTimeDuration(playerID) {
            this.defaults.durationTime = playerID.duration;
            this.elementsViewModel.getElementPlayerTimeDuration().innerHTML = this.getTimeConvert(this.defaults.durationTime);
        }
    }, {
        key: 'setScaleTime',
        value: function setScaleTime(value) {
            if (value > this.defaults.scaleTimeSize[0] + this.getScaleWidth()) value = this.getScaleWidth();
            if (value <= 0) {
                value = 0;
            }
            this.setTimeCurrent(this.defaults.durationTime * (value / 100));
            this.defaults.playerID.currentTime = this.defaults.currentTime;
            this.setScaleTimeProgress(value);
        }
    }, {
        key: 'setScaleTimeProgress',
        value: function setScaleTimeProgress(value) {
            this.elementsViewModel.getElementScaleTimeProgress().style.width = value + '%';
        }
    }, {
        key: 'setScaleTimeBuffered',
        value: function setScaleTimeBuffered(value) {
            this.elementsViewModel.getElementScaleTimeBuffered().style.width = value + '%';
        }
    }, {
        key: 'getScaleWidth',
        value: function getScaleWidth() {
            return this.elementsViewModel.getElementScaleTime().offsetWidth;
        }
    }, {
        key: 'getScalePoints',
        value: function getScalePoints() {
            var begin = this.elementsViewModel.getElementScaleTime().getBoundingClientRect().left;
            var end = this.elementsViewModel.getElementScaleTime().getBoundingClientRect().left + this.getScaleWidth();
            return [begin, end];
        }
    }, {
        key: 'getTimeToPercent',
        value: function getTimeToPercent(current, duration) {
            return current / duration * 100;
        }
    }, {
        key: 'getTimeConvert',
        value: function getTimeConvert(second) {
            function addZero(i) {
                return i < 10 ? '0' + i : i;
            }
            var dateTime = new Date();
            dateTime.setTime(second * 1000);
            var hourse = dateTime.getUTCHours() > 0 ? dateTime.getUTCHours() + ':' : '';
            var minutes = addZero(dateTime.getUTCMinutes()) + ':';
            var seconds = addZero(dateTime.getUTCSeconds());
            return hourse + minutes + seconds;
        }
    }]);

    return ScaleProgress;
}();

exports.default = ScaleProgress;

},{"../views/ElementsViewModel":9}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Translate;
function Translate() {
    var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ru';
    var object = arguments[1];

    var defaults = Object.assign({
        ru: {
            buttonPlay: 'Воспроизвести',
            buttonPause: 'Приостановить',
            buttonNext: 'Назад',
            buttonPrev: 'Вперёд',
            buttonVolume: 'Звук включён',
            buttonMuted: 'Звук отключён',
            buttonRepeat: 'Без повтора',
            buttonRepeatPlaylist: 'Повторение списка',
            buttonRepeatTrack: 'Повторение трека',
            buttonRandom: 'В случайном порядке',
            buttonRandomOff: 'По порядку',
            buttonRate: 'Скорость воспроизведения',
            buttonSubtitles: 'Субтитры',
            buttonSubtitlesOff: 'Выкл.',
            buttonWindowMaximize: 'На весь экран'
        }
    }, object);
    return defaults[locale];
}

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ElementsViewModel = require('../views/ElementsViewModel');

var _ElementsViewModel2 = _interopRequireDefault(_ElementsViewModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Volume = function () {
    function Volume() {
        var _this = this;

        var playerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Player';
        var genHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, Volume);

        this.setEventVolumeChange = function () {
            if (_this.defaults.playerID.muted) {
                _this.setMuted(_this.defaults.playerID.muted);
                return false;
            }
            _this.setScaleVolume(_this.defaults.playerID.volume * 100);
        };

        this.setEventScaleVolumeMouseDown = function () {
            _this.defaults.mouseMove = true;
            _this.defaults.scaleVolumeSize = _this.getScalePoints();
        };

        this.setEventScaleVolumeMouseMove = function (event) {
            if (_this.defaults.mouseMove) {
                _this.setScaleVolume((_this.defaults.scaleVolumeSize[0] - event.clientY) / _this.getScaleHeight() * 100);
            }
        };

        this.setEventScaleVolumeMouseUp = function (event) {
            _this.defaults.mouseMove = false;
            _this.setScaleVolume((_this.defaults.scaleVolumeSize[0] - event.clientY) / _this.getScaleHeight() * 100);
        };

        this.setEventButtonVolume = function () {
            _this.setMuted(!_this.defaults.muted);
        };

        this.defaults = {
            playerName: playerName,
            playerID: document.getElementById(playerName),
            volume: 40,
            volumeSave: null,
            muted: false,
            mouseMove: false,
            scaleVolumeSize: [],
            genHTML: genHTML
        };
        this.elementsViewModel = new _ElementsViewModel2.default(this.defaults.playerName);
        if (this.defaults.genHTML) this.elementsViewModel.createElementVolume();
    }

    _createClass(Volume, [{
        key: 'init',
        value: function init() {
            this.setScaleVolume(this.defaults.volume);
            if (this.elementsViewModel instanceof _ElementsViewModel2.default) {
                this.listenEventButtonVolume();
                this.listenEventScaleVolume();
                this.listenEventVolumeChange();
            }
        }
    }, {
        key: 'listenEventVolumeChange',
        value: function listenEventVolumeChange() {
            this.defaults.playerID.addEventListener('volumechange', this.setEventVolumeChange);
        }
    }, {
        key: 'listenEventScaleVolume',
        value: function listenEventScaleVolume() {
            this.elementsViewModel.getElementScaleVolume().addEventListener('mousedown', this.setEventScaleVolumeMouseDown);
            this.elementsViewModel.getElementScaleVolume().addEventListener('mousemove', this.setEventScaleVolumeMouseMove);
            this.elementsViewModel.getElementVolumeScaleWrapper().addEventListener('mouseup', this.setEventScaleVolumeMouseUp);
        }
    }, {
        key: 'listenEventButtonVolume',
        value: function listenEventButtonVolume() {
            this.elementsViewModel.getElementButtonVolume().addEventListener('click', this.setEventButtonVolume);
        }
    }, {
        key: 'setMuted',
        value: function setMuted(bool) {
            if (bool) {
                this.defaults.muted = bool;
                this.defaults.volumeSave = this.defaults.volume;
                this.defaults.playerID.muted = this.defaults.muted;
                this.elementsViewModel.getElementPlayerContainer().classList.add(this.elementsViewModel.classes.muted);
                this.setScaleVolumeProgress(0);
            } else {
                if (this.defaults.volume !== 0) {
                    this.defaults.muted = bool;
                    this.defaults.playerID.muted = this.defaults.muted;
                    this.elementsViewModel.getElementPlayerContainer().classList.remove(this.elementsViewModel.classes.muted);
                    this.setScaleVolumeProgress(this.defaults.volumeSave);
                }
            }
            // Генерация события изменения muted
            var setMutedEvent = new CustomEvent('mutedchange', {
                detail: {
                    muted: this.defaults.muted
                }
            });
            this.elementsViewModel.getElementPlayerContainer().dispatchEvent(setMutedEvent);
        }
    }, {
        key: 'setScaleVolume',
        value: function setScaleVolume(value) {
            if (value > 100) value = 100;
            if (value < 50 && value > 0) {
                this.elementsViewModel.getElementPlayerContainer().classList.add(this.elementsViewModel.classes.volumeMiddle);
            } else {
                this.elementsViewModel.getElementPlayerContainer().classList.remove(this.elementsViewModel.classes.volumeMiddle);
            }
            if (value <= 0) {
                value = 0;
                this.setMuted(true);
            } else {
                if (this.defaults.muted) this.setMuted(false);
            }
            this.defaults.volume = parseInt(value);
            this.defaults.playerID.volume = this.defaults.volume / 100;
            this.setScaleVolumeProgress(this.defaults.volume);
        }
    }, {
        key: 'setScaleVolumeProgress',
        value: function setScaleVolumeProgress(value) {
            this.elementsViewModel.getElementScaleVolumeProgress().style.height = value + '%';
        }
    }, {
        key: 'getScaleHeight',
        value: function getScaleHeight() {
            return this.elementsViewModel.getElementScaleVolume().offsetHeight;
        }
    }, {
        key: 'getScalePoints',
        value: function getScalePoints() {
            var begin = this.elementsViewModel.getElementScaleVolume().getBoundingClientRect().top + this.getScaleHeight();
            var end = this.elementsViewModel.getElementScaleVolume().getBoundingClientRect().top;
            return [begin, end];
        }
    }]);

    return Volume;
}();

exports.default = Volume;

},{"../views/ElementsViewModel":9}],8:[function(require,module,exports){
'use strict';
//TODO Вынести названия классов и data в переменные

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CoreViewModel = function () {
    function CoreViewModel() {
        var playerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Player';

        _classCallCheck(this, CoreViewModel);

        this.playerName = playerName;
        this.classes = {
            container: 'Player',
            playing: '__playing'
        };
        this.elements = {
            playerContainer: document.createElement('div'),
            playerControlWrapper: document.createElement('div'),
            playerControlPanel: document.createElement('div'),
            playerButtonsControlPanel: document.createElement('div'),
            playerButtonsPanel: document.createElement('div'),
            playerPlay: document.createElement('div')
        };
    }

    _createClass(CoreViewModel, [{
        key: 'createView',
        value: function createView(subtitles) {
            this.createElementPlayerContainer(subtitles);
            this.createElementPlayerControl();
        }
    }, {
        key: 'createElementPlayerContainer',
        value: function createElementPlayerContainer(subtitles) {
            this.elements.playerContainer.dataset.playerName = this.playerName;
            this.elements.playerContainer.classList.add(this.classes.container);
            this.elements.playerContainer.innerHTML = document.getElementById(this.playerName).outerHTML;
            document.getElementById(this.playerName).parentNode.replaceChild(this.elements.playerContainer, document.getElementById(this.playerName));
            if (Object.keys(subtitles).length > 0) {
                for (var item in subtitles) {
                    var playerSubtitle = document.createElement('track');
                    playerSubtitle.kind = subtitles[item].kind;
                    playerSubtitle.label = subtitles[item].label;
                    playerSubtitle.srclang = item;
                    playerSubtitle.src = subtitles[item].src;
                    document.getElementById(this.playerName).appendChild(playerSubtitle);
                }
            }
        }
    }, {
        key: 'createElementPlayerControl',
        value: function createElementPlayerControl() {
            this.elements.playerControlWrapper.classList.add('player__control-wrapper');
            this.elements.playerControlPanel.classList.add('player__control-panel');
            this.elements.playerButtonsControlPanel.classList.add('player__buttons-control-panel');
            this.elements.playerButtonsPanel.classList.add('player__buttons-panel');
            this.elements.playerPlay.classList.add('player__play');
            this.elements.playerPlay.dataset.playerButton = 'play';
            //Build base nodes
            this.elements.playerButtonsControlPanel.appendChild(this.elements.playerPlay);
            this.elements.playerControlPanel.appendChild(this.elements.playerButtonsControlPanel);
            this.elements.playerControlPanel.appendChild(this.elements.playerButtonsPanel);
            this.elements.playerControlWrapper.appendChild(this.elements.playerControlPanel);
            this.elements.playerContainer.appendChild(this.elements.playerControlWrapper);
        }
    }, {
        key: 'getElementPlayerContainer',
        value: function getElementPlayerContainer() {
            return document.querySelector('[data-player-name="' + this.playerName + '"]');
        }
    }, {
        key: 'getButtonPlay',
        value: function getButtonPlay() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="play"]');
        }
    }]);

    return CoreViewModel;
}();

exports.default = CoreViewModel;

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Translate = require('../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ElementsViewModel = function () {
    function ElementsViewModel() {
        var playerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Player';

        _classCallCheck(this, ElementsViewModel);

        this.playerName = playerName;
        this.classes = {
            volumeMiddle: '__volume-middle',
            muted: '__muted',
            random: '__random',
            repeatPlaylist: '__repeat-playlist',
            repeatTrack: '__repeat-track',
            fullScreen: '__fullscreen',
            rate: '__rate',
            subtitles: '__subtitles'
        };
        this.elements = {
            playerControlWrapper: document.querySelector('[data-player-name="' + this.playerName + '"]').querySelector('.player__control-wrapper'),
            playerButtonsControlPanel: document.querySelector('[data-player-name="' + this.playerName + '"]').querySelector('.player__buttons-control-panel'),
            playerButtonsPanel: document.querySelector('[data-player-name="' + this.playerName + '"]').querySelector('.player__buttons-panel'),
            playerTimeScale: document.createElement('div'),
            timeScaleBuffered: document.createElement('div'),
            timeScaleProgress: document.createElement('div'),
            timeScaleCurrentTime: document.createElement('div'),
            timeScaleDurationTime: document.createElement('div'),
            playerVolumePanel: document.createElement('div'),
            playerVolume: document.createElement('div'),
            playerVolumeScaleWrapper: document.createElement('div'),
            playerVolumeScale: document.createElement('div'),
            volumeScaleProgress: document.createElement('div'),
            playerRandom: document.createElement('div'),
            playerRepeat: document.createElement('div'),
            playerRatePanel: document.createElement('div'),
            playerRate: document.createElement('div'),
            playerRateMenu: document.createElement('ul'),
            playerSubtitlesPanel: document.createElement('div'),
            playerSubtitles: document.createElement('div'),
            playerSubtitlesMenu: document.createElement('ul'),
            playerWindowMaximize: document.createElement('div'),
            playerPlayOnVideo: document.createElement('div'),
            playerPrev: document.createElement('div'),
            playerNext: document.createElement('div')
        };
    }

    _createClass(ElementsViewModel, [{
        key: 'createElementScaleProgress',
        value: function createElementScaleProgress() {
            this.elements.playerTimeScale.classList.add('player__time-scale');
            this.elements.playerTimeScale.dataset.playerScale = 'time';
            this.elements.timeScaleBuffered.classList.add('time-scale__buffered');
            this.elements.timeScaleBuffered.dataset.playerScale = 'buffered';
            this.elements.timeScaleProgress.classList.add('time-scale__progress');
            this.elements.timeScaleProgress.dataset.playerScale = 'progress';
            this.elements.timeScaleCurrentTime.classList.add('time-scale__current-time');
            this.elements.timeScaleCurrentTime.dataset.playerTime = 'current';
            this.elements.timeScaleDurationTime.classList.add('time-scale__duration-time');
            this.elements.timeScaleDurationTime.dataset.playerTime = 'duration';
            this.elements.playerTimeScale.appendChild(this.elements.timeScaleBuffered);
            this.elements.playerTimeScale.appendChild(this.elements.timeScaleProgress);
            this.elements.playerTimeScale.appendChild(this.elements.timeScaleCurrentTime);
            this.elements.playerTimeScale.appendChild(this.elements.timeScaleDurationTime);
            this.elements.playerControlWrapper.insertBefore(this.elements.playerTimeScale, this.elements.playerControlWrapper.firstChild);
        }
    }, {
        key: 'createElementVolume',
        value: function createElementVolume() {
            this.elements.playerVolumePanel.classList.add('player__volume-panel');
            this.elements.playerVolume.classList.add('player__volume');
            this.elements.playerVolume.dataset.playerButton = 'volume';
            this.elements.playerVolumeScaleWrapper.classList.add('player__volume-scale-wrapper');
            this.elements.playerVolumeScale.classList.add('player__volume-scale');
            this.elements.playerVolumeScale.dataset.playerScale = 'volume';
            this.elements.volumeScaleProgress.classList.add('volume-scale__progress');
            this.elements.volumeScaleProgress.dataset.playerScale = 'volume-progress';
            this.elements.playerVolumeScale.appendChild(this.elements.volumeScaleProgress);
            this.elements.playerVolumeScaleWrapper.appendChild(this.elements.playerVolumeScale);
            this.elements.playerVolumePanel.appendChild(this.elements.playerVolume);
            this.elements.playerVolumePanel.appendChild(this.elements.playerVolumeScaleWrapper);
            this.elements.playerButtonsPanel.appendChild(this.elements.playerVolumePanel);
        }
    }, {
        key: 'createElementButtonRandom',
        value: function createElementButtonRandom() {
            this.elements.playerRandom.classList.add('player__random');
            this.elements.playerRandom.dataset.playerButton = 'random';
            this.elements.playerButtonsPanel.insertBefore(this.elements.playerRandom, this.elements.playerButtonsPanel.firstChild);
        }
    }, {
        key: 'createElementButtonRepeat',
        value: function createElementButtonRepeat() {
            this.elements.playerRepeat.classList.add('player__repeat');
            this.elements.playerRepeat.dataset.playerButton = 'repeat';
            this.elements.playerButtonsPanel.insertBefore(this.elements.playerRepeat, this.elements.playerButtonsPanel.firstChild);
        }
    }, {
        key: 'createElementRate',
        value: function createElementRate() {
            var rateList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['1'];

            this.elements.playerRatePanel.classList.add('player__rate-panel');
            this.elements.playerRate.classList.add('player__rate');
            this.elements.playerRate.dataset.playerButton = 'rate';
            this.elements.playerRateMenu.classList.add('player__rate-menu');
            this.elements.playerRateMenu.dataset.playerScale = 'rate';
            for (var i = 0; i < rateList.length; i++) {
                var playerRateMenuItem = document.createElement('li');
                playerRateMenuItem.dataset.playerRate = rateList[i];
                playerRateMenuItem.innerText = rateList[i];
                this.elements.playerRateMenu.appendChild(playerRateMenuItem);
            }
            this.elements.playerRatePanel.appendChild(this.elements.playerRate);
            this.elements.playerRatePanel.appendChild(this.elements.playerRateMenu);
            this.elements.playerButtonsPanel.insertBefore(this.elements.playerRatePanel, this.elements.playerButtonsPanel.firstChild);
        }
    }, {
        key: 'createElementButtonWindowMaximize',
        value: function createElementButtonWindowMaximize() {
            this.elements.playerWindowMaximize.classList.add('player__window-maximize');
            this.elements.playerWindowMaximize.dataset.playerButton = 'window-maximize';
            this.elements.playerButtonsPanel.appendChild(this.elements.playerWindowMaximize);
        }
    }, {
        key: 'createElementButtonPlayOnVideo',
        value: function createElementButtonPlayOnVideo() {
            this.elements.playerPlayOnVideo.classList.add('player__play-on-video');
            this.elements.playerPlayOnVideo.dataset.playerButton = 'play-on-video';
            document.querySelector('[data-player-name="' + this.playerName + '"]').insertBefore(this.elements.playerPlayOnVideo, document.querySelector('[data-player-name="' + this.playerName + '"]').firstChild);
        }
    }, {
        key: 'createElementButtonSubtitles',
        value: function createElementButtonSubtitles(subtitles) {
            this.elements.playerSubtitlesPanel.classList.add('player__subtitles-panel');
            this.elements.playerSubtitles.classList.add('player__subtitles');
            this.elements.playerSubtitles.dataset.playerButton = 'subtitles';
            this.elements.playerSubtitlesMenu.classList.add('player__subtitles-menu');
            this.elements.playerSubtitlesMenu.dataset.playerScale = 'subtitles';
            var i = 0;
            var playerSubtitlesMenuItem = document.createElement('li');
            playerSubtitlesMenuItem.dataset.playerSubtitles = null;
            playerSubtitlesMenuItem.innerText = '';
            this.elements.playerSubtitlesMenu.appendChild(playerSubtitlesMenuItem);
            for (var item in subtitles) {
                var _playerSubtitlesMenuItem = document.createElement('li');
                _playerSubtitlesMenuItem.dataset.playerSubtitles = i++;
                _playerSubtitlesMenuItem.innerText = subtitles[item].label;
                this.elements.playerSubtitlesMenu.appendChild(_playerSubtitlesMenuItem);
            }
            this.elements.playerSubtitlesPanel.appendChild(this.elements.playerSubtitles);
            this.elements.playerSubtitlesPanel.appendChild(this.elements.playerSubtitlesMenu);
            this.elements.playerButtonsPanel.insertBefore(this.elements.playerSubtitlesPanel, this.elements.playerButtonsPanel.firstChild);
        }
    }, {
        key: 'createElementButtonNext',
        value: function createElementButtonNext() {
            this.elements.playerNext.classList.add('player__next');
            this.elements.playerNext.dataset.playerButton = 'next';
            this.elements.playerButtonsControlPanel.append(this.elements.playerNext);
        }
    }, {
        key: 'createElementButtonPrev',
        value: function createElementButtonPrev() {
            this.elements.playerPrev.classList.add('player__prev');
            this.elements.playerPrev.dataset.playerButton = 'prev';
            this.elements.playerButtonsControlPanel.insertBefore(this.elements.playerPrev, this.elements.playerButtonsControlPanel.firstChild);
        }
    }, {
        key: 'getElementPlayerContainer',
        value: function getElementPlayerContainer() {
            return document.querySelector('[data-player-name="' + this.playerName + '"]');
        }
    }, {
        key: 'getElementButtonRepeat',
        value: function getElementButtonRepeat() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="repeat"]');
        }
    }, {
        key: 'getElementButtonRandom',
        value: function getElementButtonRandom() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="random"]');
        }
    }, {
        key: 'getElementButtonVolume',
        value: function getElementButtonVolume() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="volume"]');
        }
    }, {
        key: 'getElementVolumeScaleWrapper',
        value: function getElementVolumeScaleWrapper() {
            return this.getElementPlayerContainer().querySelector('.player__volume-scale-wrapper');
        }
    }, {
        key: 'getElementScaleVolume',
        value: function getElementScaleVolume() {
            return this.getElementPlayerContainer().querySelector('[data-player-scale="volume"]');
        }
    }, {
        key: 'getElementScaleVolumeProgress',
        value: function getElementScaleVolumeProgress() {
            return this.getElementPlayerContainer().querySelector('[data-player-scale="volume-progress"]');
        }
    }, {
        key: 'getElementScaleTime',
        value: function getElementScaleTime() {
            return this.getElementPlayerContainer().querySelector('[data-player-scale="time"]');
        }
    }, {
        key: 'getElementScaleTimeProgress',
        value: function getElementScaleTimeProgress() {
            return this.getElementPlayerContainer().querySelector('[data-player-scale="progress"]');
        }
    }, {
        key: 'getElementScaleTimeBuffered',
        value: function getElementScaleTimeBuffered() {
            return this.getElementPlayerContainer().querySelector('[data-player-scale="buffered"]');
        }
    }, {
        key: 'getElementPlayerTimeCurrent',
        value: function getElementPlayerTimeCurrent() {
            return this.getElementPlayerContainer().querySelector('[data-player-time="current"]');
        }
    }, {
        key: 'getElementPlayerTimeDuration',
        value: function getElementPlayerTimeDuration() {
            return this.getElementPlayerContainer().querySelector('[data-player-time="duration"]');
        }
    }, {
        key: 'getElementButtonRate',
        value: function getElementButtonRate() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="rate"]');
        }
    }, {
        key: 'getElementRateMenu',
        value: function getElementRateMenu() {
            return this.getElementPlayerContainer().querySelector('[data-player-scale="rate"]');
        }
    }, {
        key: 'getElementRateMenuItem',
        value: function getElementRateMenuItem() {
            return this.getElementRateMenu().getElementsByTagName('li');
        }
    }, {
        key: 'getElementButtonSubtitles',
        value: function getElementButtonSubtitles() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="subtitles"]');
        }
    }, {
        key: 'getElementSubtitlesMenu',
        value: function getElementSubtitlesMenu() {
            return this.getElementPlayerContainer().querySelector('[data-player-scale="subtitles"]');
        }
    }, {
        key: 'getElementSubtitlesMenuItem',
        value: function getElementSubtitlesMenuItem() {
            return this.getElementSubtitlesMenu().getElementsByTagName('li');
        }
    }, {
        key: 'getElementButtonWindowMaximize',
        value: function getElementButtonWindowMaximize() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="window-maximize"]');
        }
    }, {
        key: 'getElementButtonPlayOnVideo',
        value: function getElementButtonPlayOnVideo() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="play-on-video"]');
        }
    }, {
        key: 'getElementButtonNext',
        value: function getElementButtonNext() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="next"]');
        }
    }, {
        key: 'getElementButtonPrev',
        value: function getElementButtonPrev() {
            return this.getElementPlayerContainer().querySelector('[data-player-button="prev"]');
        }
    }]);

    return ElementsViewModel;
}();

exports.default = ElementsViewModel;

},{"../components/Translate":6}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlaylistViewModel = function () {
    function PlaylistViewModel(settings) {
        _classCallCheck(this, PlaylistViewModel);

        this.defaults = Object.assign({
            playerName: 'Player',
            playlist: {}
        }, settings);
        this.elements = {
            playerPlaylist: document.createElement('ul')
        };
    }

    _createClass(PlaylistViewModel, [{
        key: 'getNodePlaylist',
        value: function getNodePlaylist() {
            this.elements.playerPlaylist.classList.add('player__playlist');
            this.elements.playerPlaylist.dataset.playerPlaylist = this.defaults.playerName;
            for (var item in this.defaults.playlist) {
                var playerPlaylistItem = document.createElement('li'),
                    playerPlaylistItemSpan = document.createElement('span'),
                    playerPlaylistItemSpanI = document.createElement('i');
                playerPlaylistItemSpanI.innerHTML = ' — ' + this.defaults.playlist[item].band;
                playerPlaylistItemSpan.innerHTML = this.defaults.playlist[item].name;
                playerPlaylistItemSpan.appendChild(playerPlaylistItemSpanI);
                playerPlaylistItem.appendChild(playerPlaylistItemSpan);
                playerPlaylistItem.dataset.playerSrc = this.defaults.playlist[item].src;
                this.elements.playerPlaylist.appendChild(playerPlaylistItem);
            }
            return this.elements.playerPlaylist;
        }
    }, {
        key: 'getElementPlaylist',
        value: function getElementPlaylist() {
            return document.querySelector('[data-player-playlist="' + this.defaults.playerName + '"]');
        }
    }, {
        key: 'getElementPlaylistItem',
        value: function getElementPlaylistItem() {
            return document.querySelector('[data-player-playlist="' + this.defaults.playerName + '"]').getElementsByTagName('li');
        }
    }]);

    return PlaylistViewModel;
}();

exports.default = PlaylistViewModel;

},{}]},{},[1]);
